module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "bhead"
  }, [_c('span', [_vm._v("4")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _vm._v("AFFERY GOT TO BED at 4:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" Next to him Veronica slept solid and unruffled, snoring delicately. If her throat was up it meant swollen glands. Swollen glands meant the resurfacing of the Hodgkin’s, the return of the deadly lymphoma.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Timing, Veronica, perfect timing; almost as if you knew")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("At 4:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" he finally fell into a shallow, fitful sleep, only to come awake again at 5:30.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He lay staring at the ceiling thinking about the five corpses in Devonshire Drive.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Something in their injuries was significant to the killer: the marks on the heads—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Something he had made them wear? Bondage paraphernalia?")]), _vm._v("—were absent only on victim four. None of the victims had been raped; there were no signs of forced penetration—anal, oral or vaginal—and yet using an omniprint blue light, Krishnamurthi had pointed out traces of semen on the abdomens. Combined with the mutilation to the breasts of three of the women, and the lack of clothing, Caffery knew they were looking for the force’s nightmare, a sexual serial killer, someone already too ill to stop. And what lodged hardest in his head, refusing to leave, were the five bloodied shapes in the bottom of a stainless-steel bowl. Whichever way he turned those followed him.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("When he knew he wasn’t going to sleep again, he showered, dressed and without waking Veronica drove through early morning London to B team’s HQ.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("B team, sometimes called Shrivemoor after the street they were based in, shared a functional red brick building with Four Area’s")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v(" Territorial Support Group, the TSG. The exterior was anonymous, but the traffic fatalities statistics displayed in an unlit box outside had given the public the impression that this was a functioning police station. Eventually a sign had appeared outside the garage entrance warning people not to walk in here with their everyday problems. Go to a normal police station, there’s one just down the road, it said.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("By the time Caffery arrived the sun had climbed over the terraced thirties houses, schoolchildren were being ushered into Volvos. He parked the Jaguar—something else Veronica wanted him to trade for a newer, shinier version.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You could sell that and get something really nice.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I don’t want something really nice. I want the car I’ve got.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Then at least let me clean it.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He swiped his entrance card and climbed the stairs, past the TSG’s fifteen armored Ford Sherpas parked in their own spilled oil. In AMIP’s rooms the fluorescent lights were on—four database indexers, all women, all civilians, sat at their desks, tapping away.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He found Maddox in the office, fresh from breakfast with the chief superintendent. Over Earl Grey and bran muffins at Chisle-hurst golf club, the DCS had set out a game plan.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He’s slapped a moratorium on the press.” Maddox seemed weary; Jack could see he hadn’t slept. “Any female officers or civilians who find the case distressing can apply for transfer, and—” He straightened a pencil so that it lined up exactly with the other objects on his desk. His lips were colorless. “And he’s giving us reinforcements—the whole of F team bumped over here from Eltham.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Two teams on a case?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yup. The guv’s worried about this one. Really worried. Doesn’t like Krishnamurthi’s diminishing time periods. And—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maddox sighed. “The hair Krishnamurthi pulled off that girl? The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("black")]), _vm._v(" hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“He found blond hairs too. With toms, trace evidence is misleading.”")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("“Right, Jack, right. But the chief’s got Stephen Lawrence fever—all he can see are human rights groups in the shadows, razor")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v(" blades in his mail.” Someone knocked and Maddox reached for the door with a grim look on his face. “He distinctly does "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" want our target to be black.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“Morning, sir.” Detective Sergeant Paul Essex, with his usual air of good-natured dishevelment—tie unknotted, sleeves rolled up to reveal his huge red forearms—stood in the doorway holding up an orange National Identification Bureau docket. “NIB.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Prints?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yup.” He swiped thinning fair hair back from his big, flushed forehead. “Victim five was kind enough to get herself on the prostitute register. One Shellene Craw.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery opened the docket. “These were indexed on the tom register.” He looked up at Maddox. “Funny they never found their way to missing persons, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Meaning someone chez Craw has a lot of explaining to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Namely one, uh, Harrison.” He handed him the docket. “Barry Harrison. Stepney Green.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fancy putting him top of your shopping list today?” Maddox said.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And, Essex, mate, I believe you’re family-liaison officer this case. Am I correct?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You are, sir. Specially selected for my tenderness.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then you’d better go with Caffery. Someone might need your tender shoulder to cry on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Will do. And, sir, this came.” He passed a length of computer feed paper to Caffery. “From the Yard. The operation name—Operation Alcatraz.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Caffery took the paper, frowning. “Is that a joke?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay. Get on to them and have it changed. It’s not appropriate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Birdman. The Birdman of Alcatraz. Haven’t you seen the PM prelims?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I only just got here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Maddox sighed. “Our offender left us a little gift on the victims.”")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page23"
    }
  }), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Inside")]), _vm._v(" the victims,” Caffery corrected, folding his arms. “Inside the rib cage, sewn in next to the heart.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Essex’s face changed. “Nasty.” He looked from face to face, waiting for the follow-up. Maddox cleared his throat and looked at Caffery. Neither spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well?” Essex opened his hands, frustrated. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What?")]), _vm._v(" What are we talking about here? What did he leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“A bird,” Caffery said eventually. “A small bird. A cage bird, probably a finch. And that doesn’t go any further than the team. You hear?”")])])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98074af0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch_04.vue
// module id = 87
// module chunks = 0